// chat-management
const ChatManagement = () => import('@/views/setting/chat-management')

export default {
    path: 'chat-management',
    redirect: '/chat-management',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'chat-management',
            component: ChatManagement,
            meta: {
                link: 'chat-management',
                breadcrumb: [
                    { title: 'Setting', url: '/chat-management' },
                    { title: 'chat-management', active: true },
                ],
                pageTitle: 'Chat Management'
            }
        }
    ]
}